import {
  STAFF_GROUP_ALL_LIST,
  SIKDAE_STATUS_LIST,
  SIKDAE_LIST,
  SIKDAE_DETAIL,
  CANCEL_RESERVATION,
  SIKDAE_GIVE_DEDUCT,
  SIKDAE_EXCEL_CHECK,
  SIKDAE_EXCEL_UPLOAD,
  MEAL_STATUS_LIST,
  MEAL_LIST,
  MEAL_REJECTION,
  MEAL_APPROVAL,
  MEAL_APPROVAL_ACCEPTER,
  MEAL_ACCEPTER_MOD,
  LIMIT_STORE_SEL,
  SIKDAE_EXCEL_UPDLOAD_CHECK,
  SIKDAE_EXCEL_UPDLOAD,
  CHANGE_POLICY_HISTORY_SEL,
  SCHEDULE_START_DATE
} from 'actions/sikdae';

function sikdae(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case `${STAFF_GROUP_ALL_LIST}_FULFILLED`:
      return {
        ...state,
        staffGroupAllList: payload
      };
    case `${STAFF_GROUP_ALL_LIST}_PENDING`:
      return {
        ...state,
        staffGroupAllList: payload
      };
    case `${STAFF_GROUP_ALL_LIST}_REJECTED`:
      return {
        ...state,
        staffGroupAllList: payload
      };

    case `${SIKDAE_STATUS_LIST}_FULFILLED`:
      return {
        ...state,
        sikdaeStatus: payload
      };
    case `${SIKDAE_STATUS_LIST}_PENDING`:
      return {
        ...state,
        sikdaeStatus: payload
      };
    case `${SIKDAE_STATUS_LIST}_REJECTED`:
      return {
        ...state,
        sikdaeStatus: payload
      };

    case `${SIKDAE_LIST}_FULFILLED`:
      return {
        ...state,
        sikdaeGivenList: payload
      };
    case `${SIKDAE_LIST}_PENDING`:
      return {
        ...state,
        sikdaeGivenList: payload
      };
    case `${SIKDAE_LIST}_REJECTED`:
      return {
        ...state,
        sikdaeGivenList: payload
      };

    case `${SIKDAE_DETAIL}_FULFILLED`:
      return {
        ...state,
        sikdaeGivenDetail: payload
      };
    case `${SIKDAE_DETAIL}_PENDING`:
      return {
        ...state,
        sikdaeGivenDetail: payload
      };
    case `${SIKDAE_DETAIL}_REJECTED`:
      return {
        ...state,
        sikdaeGivenDetail: payload
      };

    case `${CANCEL_RESERVATION}_FULFILLED`:
      return {
        ...state,
        cancelSikdae: payload
      };
    case `${CANCEL_RESERVATION}_PENDING`:
      return {
        ...state,
        cancelSikdae: payload
      };
    case `${CANCEL_RESERVATION}_REJECTED`:
      return {
        ...state,
        cancelSikdae: payload
      };

    case `${MEAL_STATUS_LIST}_FULFILLED`:
      return {
        ...state,
        mealStatus: payload
      };
    case `${MEAL_STATUS_LIST}_PENDING`:
      return {
        ...state,
        mealStatus: payload
      };
    case `${MEAL_STATUS_LIST}_REJECTED`:
      return {
        ...state,
        mealStatus: payload
      };

    case `${MEAL_LIST}_FULFILLED`:
      return {
        ...state,
        mealList: payload
      };
    case `${MEAL_LIST}_PENDING`:
      return {
        ...state,
        mealList: payload
      };
    // 실패 payload는 에러 객체(세션 만료 AuthError 등)라 그대로 저장하면 소비처의 .data 접근에서 크래시 — null로 비운다
    case `${MEAL_LIST}_REJECTED`:
      return {
        ...state,
        mealList: null
      };

    case `${MEAL_REJECTION}_FULFILLED`:
      return {
        ...state,
        rejectMeal: payload
      };
    case `${MEAL_REJECTION}_PENDING`:
      return {
        ...state,
        rejectMeal: payload
      };
    case `${MEAL_REJECTION}_REJECTED`:
      return {
        ...state,
        rejectMeal: payload
      };

    case `${MEAL_ACCEPTER_MOD}_FULFILLED`:
      return {
        ...state,
        mealAccepterMod: payload
      };
    case `${MEAL_ACCEPTER_MOD}_PENDING`:
      return {
        ...state,
        mealAccepterMod: payload
      };
    case `${MEAL_ACCEPTER_MOD}_REJECTED`:
      console.log('#PAYLOAD: ', payload);
      return {
        ...state,
        mealAccepterMod: payload
      };

    case `${MEAL_APPROVAL_ACCEPTER}_FULFILLED`:
      return {
        ...state,
        approveAccepterMeal: payload
      };
    case `${MEAL_APPROVAL_ACCEPTER}_PENDING`:
      return {
        ...state,
        approveAccepterMeal: payload
      };
    case `${MEAL_APPROVAL_ACCEPTER}_REJECTED`:
      return {
        ...state,
        approveAccepterMeal: payload
      };

    case `${MEAL_APPROVAL}_FULFILLED`:
      console.log('PAYLOAD: ', payload);
      return {
        ...state,
        approveMeal: payload
      };
    case `${MEAL_APPROVAL}_PENDING`:
      return {
        ...state,
        approveMeal: payload
      };
    case `${MEAL_APPROVAL}_REJECTED`:
      return {
        ...state,
        approveMeal: payload
      };

    case `${SIKDAE_GIVE_DEDUCT}_FULFILLED`:
      return {
        ...state,
        sikdaeGiveDeduct: payload
      };
    case `${SIKDAE_GIVE_DEDUCT}_PENDING`:
      return {
        ...state,
        sikdaeGiveDeduct: payload
      };
    case `${SIKDAE_GIVE_DEDUCT}_REJECTED`:
      return {
        ...state,
        sikdaeGiveDeduct: payload
      };

    case `${SIKDAE_EXCEL_CHECK}_FULFILLED`:
      return {
        ...state,
        sikdae_excel_check: payload
      };
    case `${SIKDAE_EXCEL_CHECK}_PENDING`:
      return {
        ...state,
        sikdae_excel_check: payload
      };
    case `${SIKDAE_EXCEL_CHECK}_REJECTED`:
      return {
        ...state,
        sikdae_excel_check: payload
      };

    case `${SIKDAE_EXCEL_UPLOAD}_FULFILLED`:
      return {
        ...state,
        sikdae_excel_upload: payload
      };
    case `${SIKDAE_EXCEL_UPLOAD}_PENDING`:
      return {
        ...state,
        sikdae_excel_upload: payload
      };
    case `${SIKDAE_EXCEL_UPLOAD}_REJECTED`:
      return {
        ...state,
        sikdae_excel_upload: payload
      };

    case `${LIMIT_STORE_SEL}_FULFILLED`:
      return {
        ...state,
        limitStoreResult: payload
      };

    case `${LIMIT_STORE_SEL}_PENDING`:
      return {
        ...state,
        limitStoreResult: payload
      };

    case `${LIMIT_STORE_SEL}_REJECTED`:
      return {
        ...state,
        limitStoreResult: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD_CHECK}_FULFILLED`:
      return {
        ...state,
        excelUploadResult: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD_CHECK}_PENDING`:
      return {
        ...state,
        excelUploadResult: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD_CHECK}_REJECTED`:
      return {
        ...state,
        excelUploadResult: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD}_FULFILLED`:
      return {
        ...state,
        excelUpload: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD}_PENDING`:
      return {
        ...state,
        excelUpload: payload
      };

    case `${SIKDAE_EXCEL_UPDLOAD}_REJECTED`:
      return {
        ...state,
        excelUpload: payload
      };

    case `${CHANGE_POLICY_HISTORY_SEL}_FULFILLED`:
      return {
        ...state,
        history: payload
      };

    case `${CHANGE_POLICY_HISTORY_SEL}_PENDING`:
      return {
        ...state,
        history: payload
      };

    case `${CHANGE_POLICY_HISTORY_SEL}_REJECTED`:
      return {
        ...state,
        history: payload
      };

    case `${SCHEDULE_START_DATE}_FULFILLED`:
      return {
        ...state,
        scheduleStartDate: payload
      };

    case `${SCHEDULE_START_DATE}_PENDING`:
      return {
        ...state,
        scheduleStartDate: payload
      };

    case `${SCHEDULE_START_DATE}_REJECTED`:
      return {
        ...state,
        scheduleStartDate: payload
      };

    default:
      return state;
  }
}

export default sikdae;
